import { axiosInstance } from "../network";
import { API_URL } from "../../constants";

export default {
  getAllRole: () => {
    return axiosInstance.get(API_URL.GETALLROLE);
  },

  getMenu: () => {
    return axiosInstance.get(API_URL.MENU_CREATED);
  },
};
